/**
 * @constructor
 * @returns {SymbolsManager}
 */
import {SlotSymbol} from "./SlotSymbol";

export function SymbolsManager() {};

SymbolsManager.prototype.getSymbolData = function(symbol) {
	return {
		'spriteName': symbol.getName(),
		'symbolNum': symbol.getSymbolNum(),
		'symbolName': symbol.getSymbolName(),
		'px': symbol.getPosX(),
		'py': symbol.getPosY(),
		'rx': symbol.getReelX(),
		'ry': symbol.getReelY()
	};
};

/**
 * @param {*} id
 * @returns {boolean}
 */
SymbolsManager.prototype._isNumber = function (id) {
	return !isNaN(id);
};

/**
 * @param {string|number} symbolId
 * @returns {number}
 */
SymbolsManager.prototype._getSymbolNum = function(symbolId) {
	return this._isNumber(symbolId) ?
		symbolId * 1 : AbstractSymbol.getNumBySymbolName(symbolId + "");
};

/**
 * @param {string|number} symbolId
 * @returns {string}
 */
SymbolsManager.prototype._getSymbolName = function(symbolId) {
	return this._isNumber(symbolId) ? AbstractSymbol.getSymbolByNum(symbolId * 1) : symbolId + ""
};

/**
 * @param {string|number} symbolId
 * @param {number} x
 * @param {number} y
 * @param {number=} reelX
 * @param {number=} reelY
 * @param {?string=} name
 * @returns {AbstractSymbol}
 */
SymbolsManager.prototype.create = function(symbolId, x, y, reelX, reelY, name) {

	reelX = typeof reelX !== 'undefined' ? reelX : -1;
	reelY = typeof reelY !== 'undefined' ? reelY : -1;

	var symbolNum = this._getSymbolNum(symbolId);
	//var symbolName = this._getSymbolName(symbolId);
	//var sprite = MI.addImg(x, y, "symbols_atlas", name);

	var symbol = new SlotSymbol(symbolNum, reelX, reelY, name);
	symbol.init(x, y);
	symbol.setAnchor(0.5, 0.5);

	return symbol;
};

/**
 * @param {AbstractSymbol} symbol
 * @param {?string|number=} symbolId
 * @param {?string=} spriteName
 * @returns {AbstractSymbol}
 */
SymbolsManager.prototype.createFromSymbol = function(symbol, symbolId, spriteName) {

	var symbolData = this.getSymbolData(symbol);
	var sid = (typeof symbolId !== 'undefined' && symbolId !== null) ? symbolId : symbolData["symbolNum"];

	return this.create(
		sid,
		symbolData['px'],
		symbolData['py'],
		symbolData['rx'],
		symbolData['ry'],
		spriteName
	);
};

/**
 * @param {Array<AbstractSymbol>} resSymbols
 * @param {?string|number=} symbolId
 * @param {boolean=} uniqueName
 * @returns {Array<AbstractSymbol>}
 */
SymbolsManager.prototype.createAnimsSymbols = function(resSymbols, symbolId, uniqueName) {

	var animsSymbols = [];

	for(var i = 0; i < resSymbols.length; i++) {
		animsSymbols.push(this.createAnimSymbol(resSymbols[i], symbolId, uniqueName));
	}

	return animsSymbols;

};

/**
 * @param {AbstractSymbol} resSymbol
 * @param {?string|number=} symbolId
 * @param {boolean=} uniqueName
 * @returns {AbstractSymbol}
 */
SymbolsManager.prototype.createAnimSymbol = function(resSymbol, symbolId, uniqueName) {
	var name;

	if(!uniqueName) {
		name = "ANIM_" + resSymbol.getName();
	}

	var animSymbol = this.createFromSymbol(resSymbol, symbolId, name);
	animSymbol.setReelPos(resSymbol.getReelX(), resSymbol.getReelY());

	return animSymbol;
};

/**
 * @param {Array<AbstractSymbol>} resSymbols
 * @returns {Array<AbstractSymbol>}
 */
SymbolsManager.prototype.createStickySymbols = function(resSymbols) {

	var sticksySymbols = [];
	for(var i = 0; i < resSymbols.length; i++) {
		sticksySymbols.push(this.createStickySymbol(resSymbols[i]));
	}

	return sticksySymbols;
};

/**
 * @param {AbstractSymbol} resSymbol
 * @returns {AbstractSymbol}
 */
SymbolsManager.prototype.createStickySymbol = function(resSymbol) {

	var stickSymbol = this.createFromSymbol(resSymbol);
	stickSymbol.createStickSymbol(false);
	stickSymbol.setReelPos(resSymbol.getReelX(), resSymbol.getReelY());

	return stickSymbol;
};
